<template>
  <vx-card class="table-list-card">
    <vs-row>
      <vs-col>
        <div class="mb-4">
          <span class="font-bold" style="font-size: 14px"><i class="dot"></i>{{title}}</span>
        </div>

        <!-- Desktop Table Layout -->
        <div class="desktop-layout">
          <vs-table stripe ref="table" class="table" :sst="true" :data="table.list" @selected="handleItemClickDetail">
            <template slot="thead">
              <vs-th><span class="w-full text-center">No.</span></vs-th>
              <vs-th><span class="w-full text-center">작성일</span></vs-th>
              <vs-th><span class="w-full text-center">일정</span></vs-th>
              <vs-th><span class="w-full text-center">내용</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <colgroup>
                <col width="60" />
                <col width="120" />
                <col width="240" />
                <col />
              </colgroup>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="text-center">{{ getNo(indextr) }}</vs-td>
                <vs-td class="text-center">{{ getDate(tr.created_at) }}</vs-td>
                <vs-td class="text-center">{{ getScheduleText(tr) }}</vs-td>
                <vs-td class="text-center">
                  <vs-icon v-if="tr.post_parent_id" icon-pack="feather" icon="icon-corner-down-right"></vs-icon>
                  {{ tr.post_title }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <!-- Mobile Card Layout -->
        <div class="mobile-layout">
          <div class="mobile-card-list">
            <div
              v-for="(tr, indextr) in table.list"
              :key="indextr"
              class="mobile-card"
              @click="handleItemClickDetail(tr)"
            >
              <div class="mobile-card-header">
                <div class="mobile-card-number">No. {{ getNo(indextr) }}</div>
                <div class="mobile-card-date">{{ getDate(tr.created_at) }}</div>
              </div>

              <div class="mobile-card-body">
                <div class="mobile-card-title-row">
                  <div class="mobile-card-title">
                    <vs-icon v-if="tr.post_parent_id" icon-pack="feather" icon="icon-corner-down-right" class="reply-icon"></vs-icon>
                    {{ tr.post_title }}
                  </div>

                  <div
                    v-if="hasSchedule(tr)"
                    class="mobile-card-schedule"
                  >
                    <div class="schedule-label">일정 :</div>
                    <div class="schedule-value">
                      {{ getScheduleText(tr) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination
              :total="lastPage ? lastPage : 1"
              :value="currentPage"
              @change="handleTableChangePage"
            />
          </div>
        </div>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
export default {
  name: "NewsCard",
  components: { KPagination },
  props: {
    title: {
      type: String,
      required: true,
    },
    boardId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      projectTitle: "",
      table: {
        list: [],
      },

      //pagination
      perPage: 3,
      date: "",
      currentPage: 1,
      lastPage: 1,
      total: 0,

      // 중복 호출 방지를 위한 플래그
      isChangingPage: false,
    };
  },

  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
  },
  mounted() {
    this.loadPostList();
  },

  methods: {
    getNo(index) {
      return this.total - (((this.currentPage - 1) * this.perPage) + index);
    },

    getDate(date) {
      return new Date(date).format("yyyy-MM-dd");
    },

    getContent(data) {
      if (data && data.post_content) {
        try {
          const content = JSON.parse(data.post_content);
          return content;
        } catch (e) {
          return null;
        }
      }
      return null;
    },

    hasSchedule(tr) {
      const content = this.getContent(tr);
      return content && content.date && typeof content.date === 'object' && content.date.sDate && content.date.eDate;
    },

    getScheduleText(tr) {
      const content = this.getContent(tr);
      if (content && content.date && typeof content.date === 'object' && content.date.sDate && content.date.eDate) {
        return `${this.getDate(content.date.sDate)} ~ ${this.getDate(content.date.eDate)}`;
      }
      return '-';
    },

    // 게시물 불러오기
    async loadPostList() {
      const projectId = this.projectId;
      const boardId = this.boardId;
      const page = this.currentPage ? this.currentPage : 1;
      const perPage = this.perPage;
      const keyword = [];

      if (this.searchKeyword) keyword.push(`${this.searchType}*%${this.searchKeyword}%`);

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        keyword,
        orderTarget: "created_at",
        orderDirection: "desc",
        // 캐시 무력화를 위한 timestamp 추가
        _timestamp: new Date().getTime()
      });

      // 게시물 불러오기
      const postListInfo = this.$store.state.board.postListInfo;

      // 페이지네이션 정보 (currentPage는 덮어쓰지 않음)
      // this.currentPage = postListInfo.current_page; // 제거: 사용자가 설정한 페이지 유지
      this.lastPage = postListInfo.last_page;
      this.perPage = postListInfo.per_page;
      this.total = postListInfo.total;

      // 보여지는 게시물 리스트
      const list = postListInfo.data;
      const newList = [];
      for (const item of list) {
        newList.push(item);
        if (item.children && item.children.length > 0) {
          for (const subItem of item.children) {
            newList.push(subItem);
          }
        }
      }

      this.table.list = newList;
    },

    // 글 상세페이지로 이동
    moveProjectDetail(_postId) {
      this.$emit("clickPost", _postId);
    },

    handleChangePerPage(_data) {
      if (this.perPage !== _data) {
        this.currentPage = 1;
        this.perPage = _data;
        this.loadPostList();
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadPostList();
    },
    handleChangePage(_data) {
      if (this.currentPage !== _data) {
        this.currentPage = _data;
        this.loadPostList();
      }
    },
    handleItemClickDetail(_data) {
      this.moveProjectDetail(_data.id);
    },
    handleClickRegister() {
      this.$router.push({ path: "/community/unitbusinessnews/create" });
    },

    async handleTableChangePage(page) {
      // 중복 호출 방지
      if (this.isChangingPage) {
        return;
      }

      if (this.currentPage !== page) {
        this.isChangingPage = true;
        try {
          this.currentPage = page;
          await this.loadPostList();
        } finally {
          this.isChangingPage = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table::v-deep {
  .vs-table--tbody-table {
    min-width: 100%;
  }
  table {
    table-layout: fixed;
  }
}

/* Desktop Layout - 기본값 */
.mobile-layout {
  display: none;
}

.desktop-layout {
  display: block;
}

/* Mobile Layout - 768px 이하에서 적용 */
@media (max-width: 768px) {
  .table-list-card {
    margin: 0 6px;
    width: calc(100% - 12px);
  }

  .desktop-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }

  .mobile-card-list {
    min-height: 300px; /* 최소 높이 설정하여 페이지네이션이 움직이지 않도록 함 */

    .mobile-card {
      background: #fff;
      border: 1px solid #e0e6ed;
      border-radius: 8px;
      margin-bottom: 12px;
      padding: 16px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        border-color: #7367f0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .mobile-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #f0f0f0;

      .mobile-card-number {
        font-size: 12px;
        color: #6c757d;
        font-weight: 500;
      }

      .mobile-card-date {
        font-size: 12px;
        color: #6c757d;
      }
    }

    .mobile-card-body {
      .mobile-card-title-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;

        .mobile-card-title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          line-height: 1.4;
          display: flex;
          align-items: flex-start;
          flex: 1;

          .reply-icon {
            margin-right: 4px;
            margin-top: 2px;
            font-size: 12px;
            color: #7367f0;
          }
        }

        .mobile-card-schedule {
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: space-between;
          font-size: 11px;
          white-space: nowrap;
          flex-shrink: 0;

          .schedule-label {
            color: #6c757d;
            margin-right: 4px;
            font-weight: 500;
          }

          .schedule-value {
            color: #495057;
          }
        }
      }
    }
  }
}

/* 더 작은 모바일 화면 (480px 이하) */
@media (max-width: 480px) {
  .mobile-card-list {
    min-height: 280px;

    .mobile-card {
      padding: 12px;
      margin-bottom: 8px;
    }

    .mobile-card-header {
      margin-bottom: 8px;

      .mobile-card-number,
      .mobile-card-date {
        font-size: 11px;
      }
    }

    .mobile-card-body {
      .mobile-card-title-row {
        flex-direction: column;
        gap: 6px;

        .mobile-card-title {
          font-size: 13px;
          margin-bottom: 0;
        }

        .mobile-card-schedule {
          font-size: 10px;
          width: 100%;
          align-self: flex-start;
          justify-content: space-between;

          .schedule-label {
            margin-right: 3px;
          }
        }
      }
    }
  }
}

/* 페이지네이션 모바일 최적화 */
@media (max-width: 768px) {
  .vs-con-table {
    margin-top: 16px;

    .con-pagination-table {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
